import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class TextH2 extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path d="M2.2,3.2h1v3.3h3.7V3.2h1V11h-1V7.3H3.2V11h-1V3.2z" />
          <path
            d="M9.4,10.5c0.6-0.6,1.1-1.1,1.5-1.6c0.4-0.5,0.8-0.9,1.1-1.3c0.3-0.4,0.5-0.8,0.7-1.1s0.2-0.7,0.2-1c0-0.4-0.1-0.8-0.4-1.1
          C12.4,4.2,12,4,11.6,4c-0.3,0-0.6,0.1-0.9,0.3C10.4,4.5,10.1,4.7,9.9,5L9.4,4.4c0.3-0.4,0.7-0.6,1-0.8s0.8-0.3,1.3-0.3
          c0.7,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,1,0.6,1.6c0,0.4-0.1,0.7-0.2,1.1c-0.2,0.4-0.4,0.7-0.6,1.1c-0.3,0.4-0.6,0.8-1,1.2
          s-0.8,0.9-1.3,1.3c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0h2.2V11H9.4V10.5z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/TextH2.js